import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { get } from 'lodash'
import { useSnackbar } from 'notistack'
import { Button, CircularProgress, Container, Grid, TextField, Typography } from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'

import StepCard from '../../components/cards/StepCard/StepCard'
import PedidoOnline from '../../assets/svg/pedidoOnline.svg'
import useFormHooks from '../../components/hooks/useFormHooks'
import ClientHeader from '../../sections/headers/ClientHeader/ClientHeader'
import onlinePurchaseStyles from './css/onlinePurchaseStyles'

const OnlinePurchase = () => {
  const classes = onlinePurchaseStyles()
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()

  const [isLoading, setIsLoading] = useState(false)
  const [purchaseDate, setPurchaseDate] = useState(new Date())

  const initialState = {
    branch: '',
    cashNumber: '',
    transactionNumber: '',
    dni: '',
  }
  const { handleSubmit, handleInputChange, inputs, clearInputs } = useFormHooks(
    initialState,
    async () => {
      setIsLoading(true)
      try {
        setIsLoading(false)
        clearInputs()
        return history.push({
          pathname: 'seleccionar-productos',
        })
      } catch (error) {
        enqueueSnackbar(
          get(error, 'message') || get(error, 'response.data.error_description') || '',
          {
            variant: 'error',
            autoHideDuration: 1000,
          }
        )
        setIsLoading(false)

        return error
      }
    }
  )

  return (
    <div className={classes.root}>
      <Container maxWidth="md" className={classes.container}>
        <ClientHeader
          title="Compra por Ripley.com"
          subTitle="Para crear tu ticket de regalo, primero sigue estas instrucciones:"
          step="1"
          totalSteps="3"
        />
        <Grid container spacing={2} alignItems="center" justify="center">
          <Grid item xs={12}>
            <StepCard stepNumber={1}>
              <>
                <Typography align="left">
                  Ingresa a tu bandeja de correo que hayas usado para hacer tu compra online.
                </Typography>
              </>
            </StepCard>
          </Grid>
          <Grid item xs={12}>
            <StepCard stepNumber={2}>
              <div>
                <Typography align="left" gutterBottom>
                  Ubica el correo enviado por Ripley con el{' '}
                  <Typography align="left" component="span" className={classes.boldFont}>
                    número de pedido u orden
                  </Typography>{' '}
                  de compra y anótalo.
                </Typography>
                <Typography align="left">El correo se ve así:</Typography>
                <img src={PedidoOnline} alt="Pedido Online" className={classes.img} />
              </div>
            </StepCard>
          </Grid>
          <Grid item xs={12}>
            <StepCard stepNumber={3}>
              <form className={classes.formSection} onSubmit={handleSubmit}>
                <Typography align="left" className={classes.textField}>
                  Ingresa el número de orden de tu pedido en este campo:
                </Typography>
                <TextField
                  fullWidth
                  label="1 - Sucursal"
                  variant="outlined"
                  name="branch"
                  value={get(inputs, 'branch')}
                  onChange={handleInputChange}
                  className={classes.textField}
                />

                <Button
                  fullWidth
                  size="large"
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{ height: 56 }}
                >
                  {isLoading ? <CircularProgress /> : 'Continuar'}
                </Button>
              </form>
            </StepCard>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default OnlinePurchase
